<script>
export default {
   name: 'Cloud',
};
</script>

<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="none" viewBox="0 0 50 50">
      <path
         fill="#acb7e8"
         d="M41.898 17.512a.57.57 0 0 0-.59-.547c-2.197.097-3.413-2.543-1.927-4.184a.577.577 0 0 0-.035-.809l-2.051-1.902a.56.56 0 0 0-.799.035c-1.486 1.641-4.19.645-4.287-1.58a.57.57 0 0 0-.589-.546l-2.78.123a.57.57 0 0 0-.54.597c.095 2.223-2.513 3.454-4.135 1.95a.56.56 0 0 0-.717-.038c.16.507.249 1.046.249 1.607v.432h.203c.326 0 .591.268.591.6v1.404c0 .33-.264.599-.591.599h-.69v1.164c0 2.649-2.507 4.796-5.125 4.796 3.393 0 4.528 1.82 5.944 4.697-3.697 2.993-.521 1.746 2.465 1.746 1.184 0 2.677 1.238 2.737 2.648.014.315.278.56.59.546l2.78-.122a.57.57 0 0 0 .54-.597c-.095-2.224 2.514-3.455 4.135-1.951a.56.56 0 0 0 .799-.035l1.88-2.076a.577.577 0 0 0-.035-.808c-1.622-1.504-.637-4.242 1.56-4.339a.57.57 0 0 0 .54-.596z"
      />
      <path
         fill="#fff"
         d="M30.585 25.532c3.379 0 6.117-2.62 6.117-5.851 0-3.232-2.738-5.851-6.117-5.851s-6.117 2.62-6.117 5.85c0 3.232 2.739 5.852 6.117 5.852"
      />
      <path
         fill="#efb534"
         d="M27.947 21.428h-14.17a.77.77 0 0 1-.772-.773v-1.81c0-.427.345-.773.772-.773h14.17c.426 0 .772.346.772.773v1.81a.77.77 0 0 1-.773.773M22.303 15.125H19.42c-.526 0-.975-.382-1.059-.902l-.523-3.236a.904.904 0 0 1 .893-1.049h4.261c.557 0 .982.5.893 1.05l-.523 3.235c-.084.52-.533.902-1.059.902"
      />
      <path
         fill="#ffcec0"
         d="M20.862 29.113a6.184 6.184 0 0 1-6.184-6.184v-1.502h12.368v1.502a6.184 6.184 0 0 1-6.184 6.184"
      />
      <path
         fill="#0778cd"
         d="M20.862 29.114c-6.234 0-11.287 5.054-11.287 11.287l2.66 2.742 19.915 3.191v-2.741c1.36-9.45-5.054-14.479-11.288-14.479"
      />
      <path
         fill="#f6d530"
         d="M27.682 18.07v-.557a6.82 6.82 0 0 0-3.86-6.14l-.46 2.849c-.084.52-.533.902-1.06.902H19.42c-.527 0-.975-.382-1.06-.902l-.46-2.85a6.82 6.82 0 0 0-3.859 6.141v.558zM20.862 29.114c-2.284 0-4.408.68-6.184 1.847v14.31h12.368V30.96a11.23 11.23 0 0 0-6.184-1.847"
      />
      <path fill="#0778cd" d="m20.862 35.242 3.683-5.51a11.27 11.27 0 0 0-7.366 0z" />
      <path
         fill="#bbc7d5"
         d="M25 0c13.75 0 25 11.25 25 25S38.75 50 25 50 0 38.75 0 25 11.25 0 25 0m0 5c-4.75 0-9 1.5-12.25 4.25l28 28C43.25 33.75 45 29.5 45 25c0-11-9-20-20-20m12.25 35.75-28-28C6.5 16 5 20.25 5 25c0 11 9 20 20 20 4.75 0 9-1.5 12.25-4.25"
      />
   </svg>
</template>

<style scoped lang="scss"></style>
